import React from "react";
import useStyles from "../styles";
import { AddAPhoto, Close } from "@material-ui/icons";

const SimpleImageInput = ({ text, setValue, label }) => {
    const classes = useStyles();

    const fileUploadButton = () => {
        document.getElementById('fileButton').click();
        document.getElementById('fileButton').onchange = () => {
            setValue(document.getElementById('fileButton').files[0]);
        }
    }

    const onDelete = e => {
        e.preventDefault();
        setValue(null);
    }

    return (
        <>
            <div>
                <p className={classes.label} >{label}</p>
                <div>
                    {text == null ? (
                        <div className={classes.simpleImageDiv}
                            onClick={fileUploadButton}
                        >
                            <div className={classes.centerImage}>
                                <input id="fileButton" type="file" hidden />
                                <AddAPhoto className={classes.imageSize}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className={classes.simpleImageDivStack}>
                            <div className={classes.simpleImageDivNoPointer}>
                                <img src={URL.createObjectURL(text)} width="200px" height="200px" />
                            </div>
                            <div className={classes.divImageCancel} >
                                <Close classes={{ root: classes.searchIcon }}
                                    onClick={onDelete}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default SimpleImageInput;